import { Dialog } from '@mui/material'
import { parseYouTubeVideoId } from 'utils/youtube-video-url-parser'

type Props = {
  videoUrl: string
  onClose: () => void
}

export const DialogWatchVideo = ({ videoUrl, onClose }: Props) => {
  const embedVideoUrl = `https://www.youtube.com/embed/${parseYouTubeVideoId(videoUrl)}`

  return (
    <Dialog open fullWidth onClose={onClose}>
      <iframe
        title="videoFrame"
        width="100%"
        height="400"
        src={embedVideoUrl}
      ></iframe>
    </Dialog>
  )
}
